import { Box, Divider, Stack, Text } from '@mantine/core'
import React from 'react'
import ReportItem from '../ReportItem'

interface FailureComplyCaseProps {
  number: number
  item: any
}

const formatAmount = (amount: any) => {
  if (!amount || amount === '' || amount === null || amount === undefined) {
    return '-'
  }
  return `¥${amount}`
}

export default function FailureComplyCase({ number, item }: FailureComplyCaseProps) {
  const cardBackgroundColor = '#ffffff'

  return (
    <Box
      style={{
        backgroundColor: cardBackgroundColor,
        padding: 'var(--mantine-spacing-xs)',
        borderRadius: 'var(--mantine-radius-sm)',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        border: '1px solid rgba(0,0,0,0.05)',
        marginBottom: 'var(--mantine-spacing-xs)',
      }}
    >
      <Stack gap={'xs'} className={'text-gray-500'}>
        <Text size={'sm'} c={'dark'} fw={500}>
          案件（{number}）
        </Text>

        {/* 基本信息 */}
        <ReportItem name={'案件ID'} value={item?.id} />
        <ReportItem name={'案号'} value={item?.caseCode} />
        <ReportItem name={'执行法院'} value={item?.courtName} />

        {/* 时间信息 */}
        <Divider size="xs" color="gray.3" />
        <ReportItem name={'立案时间'} value={item?.caseRegTime} />
        <ReportItem name={'发布时间'} value={item?.casePublishTime} />

        {/* 个人信息 */}
        <Divider size="xs" color="gray.3" />
        <ReportItem name={'所属地域'} value={item?.areaName} />
        <ReportItem name={'性别'} value={item?.sexName} />

        {/* 失信详情 */}
        <Divider size="xs" color="gray.3" />
        <ReportItem name={'履行内容'} value={item?.obligation} />
        <ReportItem name={'判决金额'} value={formatAmount(item?.judgmentAmount)} />
        <ReportItem name={'失信行为'} value={item?.dishonestBehavior} />
        <ReportItem name={'履行情况'} value={item?.performanceStatus} />

        {/* 执行信息 */}
        <Divider size="xs" color="gray.3" />
        <ReportItem name={'执行依据文号'} value={item?.executionBasisDocNo} />
        <ReportItem name={'执行依据单位'} value={item?.executionBasisUnit} />
      </Stack>
    </Box>
  )
}
